// import { LOGIN_USER } from "../constants/loginConstants";
import { authService } from '../services/authService';

export const loginAction = (email, password) => async (dispatch) => {
  try {
    const response = await authService.login(email, password);
    // Store user and token based on role
    if (response.user && response.user.role === 'admin') {
      localStorage.setItem('adminToken', response.token);
      dispatch({ type: 'SET_USER', payload: response.user });
      return { ...response.user, role: 'admin' };
    } else {
      dispatch({ type: 'SET_USER', payload: response.user });
      localStorage.setItem('user', JSON.stringify(response.user));
      return response.user;
    }
  } catch (error) {
    throw error;
  }
};

export const registerAction = (name, email, password) => async (dispatch) => {
  try {
    const response = await authService.register(name, email, password);
    // Store only the user object
    dispatch({ type: 'SET_USER', payload: response.user });
    localStorage.setItem('user', JSON.stringify(response.user));
    return response;
  } catch (error) {
    throw error;
  }
};

export const logoutAction = () => async (dispatch) => {
  try {
    await authService.logout();
    dispatch({ type: 'SET_USER', payload: null });
    localStorage.removeItem('user');
  } catch (error) {
    throw error;
  }
};
